import { makeStyles } from "@material-ui/core";

export const useActivityItemPricingStepStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(2, 0),
        width: '100%',
        maxWidth: '700px',
    },
    sectionHeader: {
        marginBottom: theme.spacing(4),
        '& h3': {
            fontSize: '1.5rem',
            fontWeight: 600,
            margin: 0,
            color: theme.palette.text.primary,
        },
        '& p': {
            fontSize: '0.875rem',
            margin: theme.spacing(1, 0, 0),
            color: theme.palette.text.secondary,
        },
    },
    defaultNoteBanner: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        padding: theme.spacing(1, 1.25),
        backgroundColor: '#fdf8ee',
        border: '1px solid #eadfca',
        borderRadius: theme.shape.borderRadius,
    },
    defaultNoteIcon: {
        fontSize: '1.05rem',
        color: theme.palette.text.secondary,
        flexShrink: 0,
    },
    defaultNoteText: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
        lineHeight: 1.35,
    },
    allClientsHelperText: {
        display: 'block',
        fontSize: '0.75rem',
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(0.5),
        fontStyle: 'italic',
    },
    section: {
        marginBottom: theme.spacing(4),
    },
    pricingList: {
        marginTop: theme.spacing(1),
    },
    stepHeader: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(3),
        gap: theme.spacing(1.5),
        '& h4': {
            fontSize: '1rem',
            fontWeight: 600,
            margin: 0,
            color: theme.palette.text.primary,
        },
    },
    stepNumber: {
        width: 32,
        height: 32,
        borderRadius: '50%',
        backgroundColor: theme.palette.grey[200],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.875rem',
        fontWeight: 600,
        color: theme.palette.text.secondary,
    },
    lotsSection: {
        marginTop: theme.spacing(3),
    },
    lotToggleSection: {
        marginTop: theme.spacing(2),
    },
    lotsGridHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
    },
    selectAllLink: {
        fontSize: '0.875rem',
        color: theme.palette.primary.main,
        cursor: 'pointer',
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            textDecoration: 'underline',
        },
        '& .MuiCheckbox-root': {
            padding: theme.spacing(0, 0.5),
        },
    },
    lotsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: theme.spacing(2),
    },
    lotCheckbox: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(1.5),
        display: 'flex',
        alignItems: 'center',
        transition: 'all 0.2s',
        backgroundColor: theme.palette.background.paper,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
        '& .MuiFormControlLabel-root': {
            margin: 0,
            width: '100%',
        },
        '& .MuiCheckbox-root': {
            padding: theme.spacing(0, 1, 0, 0),
        },
        '& .MuiFormControlLabel-label': {
            fontSize: '0.875rem',
            fontWeight: 500,
            color: theme.palette.text.primary,
        },
    },
    defaultBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: '0.75rem',
        fontWeight: 500,
        color: '#b07d2e',
        backgroundColor: '#fdf3e3',
        border: '1px solid #e0aa55',
        borderRadius: 999,
        padding: '3px 12px',
        marginRight: theme.spacing(1),
        letterSpacing: '0.01em',
    },
    readOnlySection: {
        opacity: 0.75,
    },
    readOnlyTooltipWrap: {
        display: 'block',
        width: '100%',
        cursor: 'not-allowed',
    },
    readOnlyField: {
        pointerEvents: 'none',
    },
    disabledInputOverride: {
        '& .Mui-disabled': {
            opacity: '1 !important',
            WebkitTextFillColor: `${theme.palette.text.secondary} !important`,
            color: `${theme.palette.text.secondary} !important`,
        },
        '& .MuiInputBase-root.Mui-disabled': {
            opacity: '1 !important',
        },
    },
    defaultAccordion: {
        backgroundColor: '#fdf4e7',
        border: '1px solid #e8c97a',
        borderRadius: theme.shape.borderRadius,
        '&.Mui-expanded': {
            backgroundColor: theme.palette.background.paper,
        },
        '&:before': {
            display: 'none',
        },
    },
}));
